/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.StockOccupyMasterResponseDto>>;
export function request(
  params: API.tms.stockOccupyDetail.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupyDetail/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
